var map = {
	"./icon-source-audio.png": "4702",
	"./icon-source-img.png": "c8df",
	"./icon-source-pdf.png": "7e05",
	"./icon-source-ppt.png": "858d",
	"./icon-source-search.png": "d6c9",
	"./icon-source-unknow.png": "901f",
	"./icon-source-video.png": "fee4",
	"./icon-source-word.png": "95b9",
	"./icon-source-xlsx.png": "0996",
	"./icon-source-zip.png": "f5b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6297";